import { Dialog, Fade, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import { useEffect } from "react";

type Props = {
	open: boolean;
	onClose?: () => void;
	autoFadeOut?: boolean;
	closeOnBackdropClick?: boolean;
};

export const FinanceDialog: FC<PropsWithChildren<Props>> = ({
	open,
	onClose,
	children,
	autoFadeOut,
	closeOnBackdropClick,
}) => {
	const theme = useTheme();

	useEffect(() => {
		if (!open || !autoFadeOut) return;
		const id = setTimeout(() => onClose?.(), 4000);
		return () => clearTimeout(id);
	}, [open, autoFadeOut, onClose]);

	return (
		<Dialog
			slots={{ transition: Fade }}
			slotProps={{
				paper: { sx: { borderRadius: theme.radii.lg } },
				transition: {
					timeout: autoFadeOut ? { enter: 1000, exit: 1000 } : 0,
				},
			}}
			disableEscapeKeyDown
			onClose={(_, reason) => {
				if (!open) return;
				if (reason === "backdropClick" && !closeOnBackdropClick) return;
				onClose?.();
			}}
			open={open}
		>
			{children}
		</Dialog>
	);
};
